import { InputSkeleton } from '@/_components';
import { CardContainer, FormLayout, SectionHeadingSkeleton } from '@/_containers';

export default function Loading() {
  return (
    <>
      <CardContainer>
        <SectionHeadingSkeleton />

        <FormLayout>
          <InputSkeleton className="col-span-12 sm:col-span-4" />
          <InputSkeleton className="col-span-12 sm:col-span-4" />
          <InputSkeleton className="col-span-12 sm:col-span-4" />

          <InputSkeleton className="col-span-12 sm:col-span-4" />
          <InputSkeleton className="col-span-12 sm:col-span-4" />
          <InputSkeleton className="col-span-12 sm:col-span-4" />

          <InputSkeleton className="col-span-12 sm:col-span-4" />
          <InputSkeleton className="col-span-12 sm:col-span-4" />
          <InputSkeleton className="col-span-12 sm:col-span-4" />
        </FormLayout>
      </CardContainer>

      <CardContainer>
        <SectionHeadingSkeleton />

        <FormLayout>
          <InputSkeleton className="col-span-12 sm:col-span-6" />
          <InputSkeleton className="col-span-12 sm:col-span-6" />

          <InputSkeleton className="col-span-12 sm:col-span-6" />
          <InputSkeleton className="col-span-12 sm:col-span-6" />
        </FormLayout>
      </CardContainer>

      <CardContainer>
        <SectionHeadingSkeleton />
        <FormLayout>
          <InputSkeleton className="col-span-12" />
        </FormLayout>
      </CardContainer>

      <CardContainer>
        <SectionHeadingSkeleton />

        <FormLayout>
          <InputSkeleton className="col-span-12 sm:col-span-6" />
          <InputSkeleton className="col-span-12 sm:col-span-6" />
          <InputSkeleton className="col-span-12 sm:col-span-6" />
          <InputSkeleton className="col-span-12 sm:col-span-6" />
        </FormLayout>
      </CardContainer>
    </>
  );
}
